<template>
  <MainLayout selectMenu="9-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else class="register-container">
      <Card class="card-container " dis-hover>
        <div slot="title" class="card-title">
          {{ getTranslation('u086') }}
        </div>
        <div class="register-card">
          <div class="my-qrcode">
            <div ref="qrcode"></div>
          </div>
          <div class="my-info">
          <Row type="flex" class="form-row " >
            <Col flex="3">
            <p class="description">{{ getTranslation('u088') }}</p>
            </Col>
          </Row>
          <Row type="flex" class="form-row menu-actions">
            <Col flex="2" class="input-col">
            <Input v-model="serialNumber" readonly />
            </Col>
            <Col flex="1" class="button-col">
            &nbsp;&nbsp;<Button @click="copySerial" type="warning" icon="ios-copy-outline" class="copy-btn">{{ getTranslation('b033') }}</Button>
            </Col>
          </Row>
           <Row type="flex" class="form-row " v-if="localRegisterCode != ''">
            <Col flex="3">
            <p class="label">{{ getTranslation('m151') }}</p>
            </Col>
          </Row>
          <Row type="flex" class="form-row menu-actions" v-if="localRegisterCode != ''">
            <Col flex="2" class="input-col">
            <Input v-model="localRegisterCode" :placeholder="getTranslation('m151')" readonly/>
            </Col>
            <Col flex="1" class="button-col">
              &nbsp;&nbsp;<Button @click="copyLocalRegistration" type="warning" icon="ios-copy-outline" class="copy-btn">{{ getTranslation('b033') }}</Button>
            </Col>
          </Row>
          <Row type="flex" class="form-row ">
            <Col flex="3">
            <p class="label">{{ getTranslation('u089') }}</p>
            </Col>
          </Row>
          <Row type="flex" class="form-row menu-actions">
            <Col flex="2" class="input-col">
            <Input v-model="registrationCode"  class="code-input" @on-enter="submitRegistration"/>
            </Col>
            <Col flex="1" class="button-col">
              &nbsp;&nbsp;<Button @click="copyRegistration" type="warning" icon="ios-copy-outline" class="copy-btn">{{ getTranslation('b033') }}</Button>
            </Col>
          </Row>
          <Row type="flex" class="button-form-row menu-actions">
            <Col flex="3" class="input-col flex-middle">
            <Button type="success" icon="ios-key" :loading="loading" @click="submitRegistration" class="submit-btn">
              {{ getTranslation('u093') }}
            </Button>
            </Col>
          </Row>
          </div>
        </div>
      </Card>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import NoAuth from '@/components/NoAuth.vue'
import { mapGetters } from 'vuex'
import { API_URL } from '@/constants/const.js'
import axios from 'axios'
import { postJsError } from '@/util/util.js'
import QRCode from 'qrcodejs2'
export default {
  name: 'RegisterIndex',
  components: {
    MainLayout,
    NoAuth,    
  },
  props: {},
  data() {
    return {
      hasAuth: true,
      serialNumber: '',
      registrationCode: '',
      localRegisterCode:'',
      loading: false,
      message: '',
      messageType: '' // 'success' or 'error'
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
  },
  mounted() { },
  created() {
    this.setBreadcrumbItems()
    this.getData()
  },
  methods: {
    async getData() {
      const url = API_URL['registerInit']
      const res = await axios.get(url
      ).catch((err) => {
        postJsError(err)        
      })
      if (res && res.data && res.data.code === 200) {
        this.serialNumber = res.data.data.serial_show || '';
        this.localRegisterCode = res.data.data.register_code || '';
        this.hasAuth = true;
        if(this.serialNumber !=""){
          new QRCode(this.$refs.qrcode, {
            text: this.serialNumber,
            width: 180,
            height: 180,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
          });
        }
      }else if (res && res.data && res.data.code == 3001) {
        this.hasAuth = false;
      } else  if (res && res.data && res.data.msg) {
        this.$Message.error(res.data.msg);
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }

    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['u085']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('u085') }
        ])
      }      
    },
    copySerial() {
      if (!this.serialNumber) return
      navigator.clipboard.writeText(this.serialNumber)
        .then(() => {
          this.$Message.success(this.getTranslation('u091'))
        })
        .catch(() => {       
          this.$Message.error(this.getTranslation('u092'))
        })
    },
    copyRegistration() {
      if (!this.registrationCode) return
      navigator.clipboard.writeText(this.registrationCode)
        .then(() => {
          this.$Message.success(this.getTranslation('u091'))
        })
        .catch(() => {
          
          this.$Message.error(this.getTranslation('u092'))
        })
    },
    copyLocalRegistration() {
      if (!this.localRegisterCode) return
      navigator.clipboard.writeText(this.localRegisterCode)
        .then(() => {
          this.$Message.success(this.getTranslation('u091'))
        })
        .catch(() => {
          
          this.$Message.error(this.getTranslation('u092'))
        })
    },
    async submitRegistration() {
      if (!this.registrationCode.trim()) {
        this.$Message.error(this.getTranslation('u099'))
        return
      }     
      this.loading = true
      const url = API_URL['registerPost']
      const data = new FormData()
      data.append('serialNumber', this.serialNumber.trim())
      data.append('registrationCode', this.registrationCode.trim())
      let res = await axios.post(url, data
      ).catch((err) => {
        postJsError(err)        
      })
      if (res && res.data && res.data.code === 200) {
        this.$Modal.success({
            title: "",
            content: res.data.msg,
            okText: this.getTranslation('b181'),
            onOk: () => {            
            }
          })
        
      }else if (res && res.data && res.data.code == 3001) {
        this.hasAuth = false;
      } else  if (res && res.data && res.data.msg) {
        this.$Message.error(res.data.msg);
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
      this.loading = false
    },
 
    
  }
}
</script>

<style scoped>
@import url('../../assets/style/list.css');
@import url('../../assets/style/tab.css');

.register-card {
  padding: 16px;
  width: 60%;
  min-width: 900px;
  margin: 0 auto;
  align-items: center;
  display: block;
  justify-content: center;
  border-radius: 12px;
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
  background: rgba(248, 249, 250, 255);

  color: rgba(50, 50, 93, 255);

  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  line-height: 25.6px;
  letter-spacing: 0px;
  text-align: left;


}

.form-row {
  margin-bottom: 6px;
}
.button-form-row {
  margin-top: 28px;
}
.my-qrcode{
  width: 20%;
  display: inline-block;
}
.my-info{
  margin-left:20px;
  display: inline-block;
  width: 75%;
  height: 100%;
  vertical-align: top;
}
</style>
